// components/FAQ.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FAQ.css';

const FAQ = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: t('question1'), answer: t('reponse1') },
    { question: t('question2'), answer: t('reponse2') },
    { question: t('question3'), answer: t('reponse3') },
    { question: t('question4'), answer: t('reponse4') },
    { question: t('question5'), answer: t('reponse5') }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="faq-wrapper">
          <div className="faq-header">
            <h2>FAQ</h2>
            <h3>{t('msg_faq')}</h3>
          </div>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                  <span className="faq-number">{String(index + 1).padStart(2, '0')}.</span>
                  <span>{faq.question}</span>
                  <span className="faq-toggle">
                    {activeIndex === index ? <i className="fas fa-minus"></i> : <i className="fas fa-plus"></i>}
                  </span>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;